/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-confusing-browser-globals */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect, useMemo } from 'react';
import { getQueryParams, stringifyQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { useThrottledFunc } from '../../hooks/FunctionHooks';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { useSelector } from 'react-redux';
import { validatedQueryParamTermForSkuSelector, validateQueryParamTermForCrmSuiteSelector } from '../../selectors/OfferSelectors';
import { queryParamTermSelector } from '../../selectors/QueryParamTermSelectors';
import { updateQueryParamTerm } from '../../actions/QueryParamTermActions';
import { parse } from 'hub-http/helpers/params';
import { useLocation } from 'react-router-dom';
import { ProductApiNames } from 'pricing-pages-lib/constants/ProductApiNames';
const setQueryParams = updatedParams => {
  const newQueryString = stringifyQueryParams(Object.assign({}, getQueryParams(), updatedParams));
  const newUrl = `${window.location.pathname}?${newQueryString}`;
  history.replaceState(history.state, '', newUrl);
};
export const useQueryParamsEffect = params => {
  const throttledSetQueryParams = useThrottledFunc(setQueryParams, 300);
  useEffect(() => {
    throttledSetQueryParams(params);
  }, [params]);
};
export const useQueryParamTerm = () => {
  const dispatch = useAppDispatch();
  const queryParamTerm = useSelector(queryParamTermSelector);
  const setQueryParamTerm = updatedQueryParamTerm => {
    if (!updatedQueryParamTerm) return;
    dispatch(updateQueryParamTerm(updatedQueryParamTerm));
  };
  return {
    queryParamTerm,
    setQueryParamTerm
  };
};
export const useValidatedQueryParamTerm = skuId => {
  const queryParamState = useQueryParamTerm();
  const {
    setQueryParamTerm
  } = queryParamState;
  const queryParamTerm = useAppSelector(state => validatedQueryParamTermForSkuSelector(state, {
    skuId,
    queryParamTerm: queryParamState.queryParamTerm
  }));
  return {
    queryParamTerm,
    setQueryParamTerm
  };
};
export const useValidatedCrmSuiteQueryParamTerm = ({
  productLevel
}) => {
  const queryParamState = useQueryParamTerm();
  const {
    setQueryParamTerm
  } = queryParamState;
  const queryParamTerm = useAppSelector(state => validateQueryParamTermForCrmSuiteSelector(state, {
    queryParamTerm: queryParamState.queryParamTerm,
    productLevel
  }));
  return {
    queryParamTerm,
    setQueryParamTerm
  };
};
export const _getQueryParamFromLocation = ({
  paramKey,
  location
}) => {
  let queryParam;
  if (location) {
    const query = parse(location.search.slice(1));
    if (query) {
      if (query[paramKey]) {
        queryParam = decodeURIComponent(query[paramKey]);
      } else if (query[paramKey.toLowerCase()]) {
        // shortlinks will lowercase passthrough query params so we have to check both
        queryParam = decodeURIComponent(query[paramKey.toLowerCase()]);
      }
    }
  }
  return queryParam;
};
export const useQueryParamFromLocation = paramKey => {
  return _getQueryParamFromLocation({
    paramKey,
    location: useLocation()
  });
};
export const useQuery = () => {
  const {
    search
  } = useLocation();
  return useMemo(() => {
    return parse(search.slice(1));
  }, [search]);
};
export const useCurrentParam = paramName => {
  const query = useQuery();
  return query[paramName] || null;
};
export const useValidatedQueryParamApiNamesForCompare = () => {
  const products = useCurrentParam('products');
  const apiNames = products ? Array.isArray(products) ? [...new Set(products)] : [products] : [];
  return apiNames.filter(apiName => ProductApiNames.includes(apiName)).slice(0, 4);
};